export default {
  getCategories(state) {
    return state.categories;
  },
  getBrands(state) {
    return state.brands;
  },
  getHierarchyCategories(state) {
    return state.hierarchyCategories;
  },
  getGroupCategories(state) {
    return state.groupCategories;
  },
  getCategoryAttributes(state) {
    return state.categoryAttributes;
  },
  getCategoryAttributesById: (state) => (id) => {
    return state.categoryAttributes[id] || null;
  },
  getExchangeRates(state) {
    return state.exchangeRates;
  },
  getSelectedCategoryId(state) {
    return state.selectedCategoryId;
  },

  // Loading states
  isCategoriesLoading(state) {
    return state.isLoading.categories;
  },
  isBrandsLoading(state) {
    return state.isLoading.brands;
  },
  isHierarchyCategoriesLoading(state) {
    return state.isLoading.hierarchyCategories;
  },
  isGroupCategoriesLoading(state) {
    return state.isLoading.groupCategories;
  },
  isCategoryAttributesLoading(state) {
    return state.isLoading.categoryAttributes;
  },
  isExchangeRatesLoading(state) {
    return state.isLoading.exchangeRates;
  },

  // Error states
  getCategoriesError(state) {
    return state.errors.categories;
  },
  getBrandsError(state) {
    return state.errors.brands;
  },
  getHierarchyCategoriesError(state) {
    return state.errors.hierarchyCategories;
  },
  getGroupCategoriesError(state) {
    return state.errors.groupCategories;
  },
  getCategoryAttributesError(state) {
    return state.errors.categoryAttributes;
  },
  getExchangeRatesError(state) {
    return state.errors.exchangeRates;
  },

  // Combined getters
  getCategoriesWithLoading(state) {
    return {
      data: state.categories,
      isLoading: state.isLoading.categories,
      error: state.errors.categories,
    };
  },
  getBrandsWithLoading(state) {
    return {
      data: state.brands,
      isLoading: state.isLoading.brands,
      error: state.errors.brands,
    };
  },
};
